<ion-split-pane contentId="tracker" when="md">
    <ion-menu contentId="tracker" menuId="tracker" side="end" type="overlay">
        @if (tie(); as tie) {
            <ion-header>
                <ion-toolbar>
                    <app-tie-scorecard [tie]="tie" type="side-menu"></app-tie-scorecard>
                </ion-toolbar>
            </ion-header>
            <ion-content>
                <app-tie-match-list [tie]="tie"></app-tie-match-list>
            </ion-content>
        }
    </ion-menu>
    <ion-router-outlet id="tracker"></ion-router-outlet>
</ion-split-pane>